/* import __COLOCATED_TEMPLATE__ from './actions.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import { CardData } from '@square/dashboard-protos/models/squareup/bizbank/service';
import { initializeAction as initializeBillingAddressAction } from '@banking/ui/workflows/card-settings/billing-address';

// defined in frontend/dashboard/lib/account-settings/app/utils/square-card/card-utils.js
let Actions = (_dec = service('card-management/billing-address-modal'), (_class = class Actions extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "dataApi", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _initializerDefineProperty(this, "billingAddressModalState", _descriptor3, this);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor4, this);
    _initializerDefineProperty(this, "isNotificationPreferencesOpen", _descriptor5, this);
    _initializerDefineProperty(this, "isAtmLimitsOpen", _descriptor6, this);
  }
  get canViewAtmLimit() {
    return this.args.card.cardState === CardData.CardState.ACTIVE;
  }
  get showCloseCheckingPrompt() {
    return this.args.isOrderNewCardState && this.storedBalanceProductPositioning.productName === ProductName.CheckingAndDebit;
  }
  toggleNotificationPreferences(value) {
    this.isNotificationPreferencesOpen = value;
  }
  onEditNotificationPreferencesClick() {
    this.toggleNotificationPreferences(true);
    this.dataApi.track('Click Checking Settings', {
      feature: 'Checking Settings',
      applet: 'Banking',
      page: 'Checking Settings',
      target: 'Manage Notifications',
      unitToken: this.args.unitToken
    });
  }
  toggleAtmLimits(value) {
    this.isAtmLimitsOpen = value;
  }
  onAtmLimitsClick() {
    this.toggleAtmLimits(true);
    this.dataApi.track('Click Checking Settings', {
      feature: 'Checking Settings',
      applet: 'Banking',
      page: 'Checking Settings',
      target: 'ATM Limits',
      unitToken: this.args.unitToken
    });
  }
  openBillingAddressModal() {
    this.billingAddressModalState.emit(initializeBillingAddressAction(this.args.unitToken));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "billingAddressModalState", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isNotificationPreferencesOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isAtmLimitsOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggleNotificationPreferences", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleNotificationPreferences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEditNotificationPreferencesClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEditNotificationPreferencesClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAtmLimits", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAtmLimits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAtmLimitsClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAtmLimitsClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openBillingAddressModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openBillingAddressModal"), _class.prototype)), _class));
export { Actions as default };